const offersPath = '/offers';
export const createOffer = offersPath;
export const getOffers = offersPath;
export const getOfferById = (id: number) => `${offersPath}/${id}`;
export const updateOffer = (id: number) => `${offersPath}/${id}`;

export const sortOrder = `${offersPath}/sort-order`;
